import React, { Component } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import servicioAsignacionValoresObjetos from "../servicio/ServicioObjetos";
import servicioHttp from "../servicio/ServicioHttp";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Growl } from "primereact/growl";
import { Dialog } from "primereact/dialog";
import { Message } from "primereact/message";
import { PickList } from 'primereact/picklist';
import { Dropdown } from 'primereact/dropdown';
import servicioObjetos from '../servicio/ServicioObjetos';

const TITULO_CREAR_PERFIL="Creación de perfil";
const TITULO_EDICION_PERFIL="Edición del perfil";
export default class PerfilCliente extends Component {
  constructor() {
    super();
    this.state = {
      perfilUsuarioAdministrador: false,
      verModalPerfil: false,      
      mostrarModalConfirmacion: false,
      mostrarModalNoAdministrador: false,      
      errores: {},
      perfil: {},
      accionesDisponibles: [],
      accionesAsignadas: [],      
      erroresMenu: {},      
      losEstados: [
        { label: "Activo", value: 1 },
        { label: "Inactivo", value: 0 }],
      icon: [
        { label: 'Seleccionar Icono', value: null },
        { label: 'Principal', value: "home" },
        { label: 'Guardar', value: "save" },
        { label: 'Eliminar', value: "delete" },
        { label: 'Usuario', value: "person" },
        { label: 'Grupos', value: "group" },
        { label: 'Telefono', value: "call" }
      ],      
      paginacion: {
        registrosPorPagina: 20,
        join: { "ttUsuarios": "alias_ttUsuarios" },
        restriccionesDinamicas: [
        ]
      }
    };
  }

  componentDidMount() {
    this.obtenerPerfiles();
  }

  templateAccion = (accion) => {    
    return (
      <div className="p-clearfix">
        <div style={{ fontSize: '14px', float: 'center', margin: '15px 5px 0 0' }}>{accion.label} <i className={'pi-md-'+accion.icon}></i></div>
      </div>
    );
  }

  obtenerAccionesCliente = () => {
    return new Promise(function (resolve, reject) {
      servicioHttp.consumirPostHttp("accion/consultar_acciones_cliente.json").then((response) => {
        resolve(response.data);
      }).catch((error) => {
        reject(error);
      });
    });
  };

  asignacionDeAcciones = (event) => {
    this.setState({
      accionesDisponibles: event.source,
      accionesAsignadas: event.target
    });
  }

  resetFormulario = () => {
    this.setState({ verModalPerfil: false });
    this.setState({
      perfil: {},
      mostrarModalConfirmacion: false,
      errores: {},
    });
  };

  eliminar = () => {
    const { perfil } = this.state;
    servicioHttp
      .consumirPostHttp("perfil/eliminar.json", perfil)
      .then(() => {
        this.setState({
          perfil: {},

          mostrarModalConfirmacion: false,
        });
        this.obtenerPerfiles();
      })
      .catch((error) => console.error(error));
  };

  mostrarModalNuevoPerfil = () => {
    this.obtenerAccionesCliente().then(response => {      
      this.setState({ verModalPerfil: true, 
        accionesDisponibles: response.objeto,
        accionesAsignadas:[],
        tituloModalPerfil:TITULO_CREAR_PERFIL });
    }).catch(error => {

    });
  };

  obtenerPerfiles = () => {
    let { paginacion } = this.state;
    paginacion.numeroPagina=0;
    servicioHttp.consumirPostHttp('perfil/consultar.json', paginacion).then((response) => {
      if(servicioObjetos.esObjetoVacio(response.data.objeto.datos))
        this.growl.show({ severity: 'warn', summary: 'Sin registros', detail: 'No cuenta con perfiles registrados' });
      this.setState({ paginacion: response.data.objeto });
    }).catch((error) => console.error(error));
  };

  mostrarModalEliminar = (objeto) => {
    const { perfilUsuarioAdministrador } = this.state;
    if (perfilUsuarioAdministrador) {
      this.setState({ mostrarModalConfirmacion: true, perfil: objeto });
    } else {
      this.setState({ mostrarModalNoAdministrador: true });
    }
  };

  guardar = () => {
    const { perfil, accionesAsignadas } = this.state;
    let validForm = this.validarFormulario(perfil, accionesAsignadas);
    this.setState({ errores: validForm });
    if (servicioObjetos.esObjetoVacio(validForm)) {
      perfil.menuWrappers = accionesAsignadas;
      let estatus = perfil.estatus;
      delete perfil['estatus'];
      perfil.estatus = estatus;
      servicioHttp
        .consumirPostHttp("perfil/guardar.json", perfil)
        .then((response) => {
          this.growl.show({ severity: 'success', summary: 'Exito', detail: response.data.mensaje });
          this.setState({
            perfil: {},
            accionesAsignadas: [],
            mostrarModalConfirmacion: false,
            verModalPerfil: false
          });
          this.obtenerPerfiles();
        })
        .catch((e) => {
          console.error(e);
          this.growl.show({ severity: 'error', summary: 'Error', detail: "No se guardo el perfil" });
        });
    }
  };

  validarFormulario = (valor, menus) => {
    const error = {};
    if (servicioObjetos.esObjetoVacio(valor.nombre))
      error.nombre = "El campo es requerido";

    if (servicioObjetos.esObjetoVacio(valor.descripcion))
      error.descripcion = "El campo es requerido";

    if (servicioObjetos.esObjetoVacio(valor.estatus))
      error.estatus = "El campo es requerido";

    if (menus.length === 0)
      error.listaMenus = "Debe de asignar al menos 1 menú"

    return error;
  };

  llenardatos = (event) => {
    servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, false);
  };
  columnaEstatus = (objeto) => {
    if (objeto.estatus === 1)
      return <p style={{ backgroundColor: '#ff9f00', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Activo</p>;
    if (objeto.estatus === 0)
      return <p style={{ backgroundColor: '#f008', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Inactivo</p>;

  }

  preEditar = (objeto) => {    
    objeto=JSON.parse(JSON.stringify(objeto));
    this.obtenerAccionesCliente().then(response => {
      let todosLosPermisos = response.objeto;
      servicioHttp.consumirPostHttp("acciones/obtener_asignadas_perfil.json", { id: objeto.id })
        .then((response) => {
          let losPermisosAsignados = response.data.lista;
          for (let index = 0; index < losPermisosAsignados.length; index++) {
            let elementoBuscar = todosLosPermisos.find(permiso => permiso.id === losPermisosAsignados[index].id);
            if (undefined !== elementoBuscar) {
              servicioAsignacionValoresObjetos.eliminarObjetoMapa(todosLosPermisos, elementoBuscar);
            }
          }
          let { losEstados } = this.state;
          let objetoEstado = servicioObjetos.obtenerObjetoDeArregloPorPropiedad(losEstados, 'value', objeto.estatus);
          objeto.estatus = objetoEstado.value;

          let losPermisoDisponiblesFinales=[];
          for (let index = 0; index < losPermisosAsignados.length; index++) {
            losPermisoDisponiblesFinales.push({
              id:losPermisosAsignados[index].id,
              label:losPermisosAsignados[index].nombre,
              icon:losPermisosAsignados[index].icono
            });
          }
          this.setState({
            verModalPerfil: true,
            accionesDisponibles: todosLosPermisos,
            accionesAsignadas: losPermisoDisponiblesFinales,
            perfil: objeto,
            tituloModalPerfil:TITULO_EDICION_PERFIL
          });
        }).catch((error) => {
          console.error(error);
        });
    }).catch(error => {
      console.error(error);
    });
  }


  plantillaOpciones = (rowData, column) => {
    return (
      <div className="p-grid">
        <div className="p-col-12 p-md-2">
          <Button
            type="button"
            icon="pi-md-edit"
            onClick={() => this.preEditar(rowData)}
            className="p-button-warning"
            name="editar"
            tooltip="Editar perfil"
          ></Button>
          <Button
            type="button"
            icon="pi-md-delete"
            onClick={(e) => this.mostrarModalEliminar(rowData)}
            className="p-button-danger"
            name="eliminar"
            tooltip="Eliminar perfil"
          ></Button>
        </div>
      </div>
    );
  }

  render() {
    const { perfil, paginacion, errores, losEstados, accionesDisponibles, accionesAsignadas,tituloModalPerfil } = this.state;

    const pieDialogo = (
      <div className="ui-dialog-buttonpane p-clearfix">
        <Button
          label="Crear"
          icon="pi-md-check"
          onClick={this.guardar}
        />
        <Button
          label="Cancelar"
          icon="pi-md-close"
          onClick={this.resetFormulario}
          className="p-button-danger "
        />
      </div>
    );
    // boton de confirmacion
    const dialogFooterConfirmacionEliminar = (
      <div>
        <Button
          icon="pi-md-check"
          onClick={this.eliminar}
          label="Si estoy seguro"
          className="p-button flat-btn"
        />
        <Button
          icon="pi-md-close"
          onClick={() =>
            this.setState({
              perfil: {},
              mostrarModalConfirmacion: false,
              errores: {},
            })
          }
          label="No estoy seguro"
          className="p-button-danger flat-btn"
        />
      </div>
    );
    const dialogFooterNoAdmin = (
      <div>

        <Button
          icon="pi-md-close"
          onClick={() =>
            this.setState({
              perfil: {},
              mostrarModalNoAdministrador: false,

            })
          }
          label="cerrrar"
          className="p-button-danger flat-btn"
        />
      </div>
    );


    return (
      <div className="p-grid">
        <Growl ref={(el) => (this.growl = el)} />
        <div className="p-col-12">
          <div className="card card-w-title">
            <h1>Mis perfiles</h1>
            <div className="p-fluid p-grid">
              <div className="p-col-12 p-md-4">
                <Button
                  className="p-button-Primary p-button-raised"
                  label="Crear perfil"
                  icon="pi-md-plus"
                  tooltip={"Crear Perfil"}
                  onClick={this.mostrarModalNuevoPerfil}
                />
              </div>
            </div>
          </div>
        </div>

        <Dialog
          visible={this.state.verModalPerfil}
          style={{ width: "60%" }}
          header={tituloModalPerfil}
          modal={true}
          footer={pieDialogo}
          onHide={this.resetFormulario}
        >
          <div className="p-grid form-group">
            <div className="p-col-12 p-lg-6">
              <span className="md-inputfield">
                <InputText
                  id="nombre"
                  name="perfil.nombre"
                  value={perfil.nombre || ""}
                  className={errores.nombre ? "p-error" : ""}
                  onChange={this.llenardatos}
                />
                <label>* Perfil</label>
                {errores.nombre ? (
                  <div>
                    <br /> <Message severity="error" text={errores.nombre} />{" "}
                  </div>
                ) : null}
              </span>
            </div>
            <div className="p-col-12 p-lg-6">
              <span className="md-inputfield">
                <InputText
                  id="descripcion"
                  name="perfil.descripcion"
                  value={perfil.descripcion || ""}
                  className={errores.descripcion ? "p-error" : ""}
                  onChange={this.llenardatos}
                />


                <label>* Descripción</label>
                {errores.descripcion ? (
                  <div>
                    <br /> <Message severity="error" text={errores.descripcion} />{" "}
                  </div>
                ) : null}
              </span>
            </div>
            <div className="p-col-12 p-lg-6">
              <Dropdown
                id="estatus"
                name="perfil.estatus"
                placeholder="* Estatus"
                optionLabel="label"
                optionValue="value"
                options={losEstados}
                value={perfil.estatus}
                onChange={(e) => { this.llenardatos(e) }}
                autoWidth={false} style={{ width: "90%" }}
                appendTo={document.body} />
              {errores.estatus ? <div><Message severity="error" text={errores.estatus} /></div> : null}
            </div>
            <div className="p-col-12 p-lg-6">
            </div>

            <div className="p-col-12 p-lg-12">
              <PickList
                source={accionesDisponibles}
                showSourceControls={false}
                showTargetControls={false}
                target={accionesAsignadas}
                itemTemplate={this.templateAccion}
                sourceHeader="Menús del sistema"
                targetHeader="Menús relacionados al perfil"
                responsive={true}
                sourceStyle={{ height: '300px' }}
                targetStyle={{ height: '300px' }}
                onChange={this.asignacionDeAcciones}></PickList>
              {errores.listaMenus ? (
                <Message severity="error" text={errores.listaMenus} />
              ) : null}
            </div>
          </div>
        </Dialog>

        <Dialog
          header="Confirmación"
          visible={this.state.mostrarModalConfirmacion}
          modal={true}
          style={{ width: "30vw" }}
          footer={dialogFooterConfirmacionEliminar}
          onHide={() =>
            this.setState({
              perfil: {},
              mostrarModalConfirmacion: false,
              errores: {},
            })
          }
        >
          <h2>¿Estás seguro que deseas eliminar el perfil?</h2>
        </Dialog>

        <Dialog
          header="Aviso"
          visible={this.state.mostrarModalNoAdministrador}
          modal={true}
          style={{ width: "30vw" }}
          footer={dialogFooterNoAdmin}
          onHide={() =>
            this.setState({
              perfil: {},
              mostrarModalNoAdministrador: false,
              errores: {},
            })
          }
        >
          <h2>No se puede eliminar el perfil, porque no eres Administrador del sistema</h2>
        </Dialog>
        <div className="p-col-12">
          <div className="card card-w-title">
            <DataTable
              value={paginacion.datos}
              editable={true}
              selectionMode="single"
              responsive={true}
              header="Detalle del Perfil"
              paginator={true}
              rows={5}
              resizableColumns={true}
            >
              <Column field="nombre" header="Perfil" autoLayout={true} />
              <Column body={this.columnaEstatus} header="Estatus" autoLayout={true} />
              <Column field="descripcion" header="Detalle" autoLayout={true} />
              <Column
                header="Opciones"
                body={this.plantillaOpciones}
                autoLayout={true}
              />
            </DataTable>
          </div>
        </div>
      </div>
    );
  }
}
